/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { CustomerPortalIntegrationType, Subscription } from '../../contexts/CustomerPortalContext';

export function getLicenseKeyFromUserData(
	userData: CustomerPortalIntegrationType[ 'customerPortalAccount' ],
	type?: 'trial' | 'development'
): string | null {
	if ( !userData?.subscriptions ) {
		return null;
	}

	const firstSubscriptionWithKeysDefined = userData.subscriptions.filter( sub => sub.keys?.length )[ 0 ];
	const keys = firstSubscriptionWithKeysDefined?.keys ?? [];

	const ckeditorKeys = keys.find( ( { label } ) => label.toLowerCase() === 'ckeditor' );

	if ( !ckeditorKeys ) {
		return null;
	}

	const ckeditor5License = ckeditorKeys.children.find( ( { label, versionRange } ) => {
		return label.toLowerCase() === 'ckeditor 5' && versionRange.from === '44.0.0';
	} );

	if ( !ckeditor5License ) {
		return null;
	}

	const keyTypeToUse = type || ( isTrialActive( firstSubscriptionWithKeysDefined ) ? 'trial' : 'development' );
	const licenseKey = ckeditor5License.keys.find( ( { type } ) => type === keyTypeToUse );

	// See: https://github.com/ckeditor/ckeditor5-builder/issues/1165.
	if ( !licenseKey ) {
		return null;
	}

	return licenseKey.value;
}

function isTrialActive( subscription: Subscription ) {
	if ( !subscription.details.trial ) {
		return false;
	}

	const date = subscription.details.trial.until;

	return new Date() < new Date( date );
}
